import { render, staticRenderFns } from "./breeddetail.vue?vue&type=template&id=652d0950&scoped=true&"
import script from "./breeddetail.vue?vue&type=script&lang=js&"
export * from "./breeddetail.vue?vue&type=script&lang=js&"
import style0 from "./breeddetail.vue?vue&type=style&index=0&id=652d0950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d0950",
  null
  
)

export default component.exports